import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-xanos',
  templateUrl: './video-xanos.component.html',
  styleUrls: ['./video-xanos.component.css']
})
export class VideoXanosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
